import * as yup from "yup";

export const returnRejectionFormSchema = yup.object({
  orderId: yup.string().required(),
  cancellationReason: yup
    .string()
    .required("This field is required")
    .min(5, "Cancellation reason field should contain at least 5 letters")
});
